'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _omit2 = require('lodash/omit');

var _omit3 = _interopRequireDefault(_omit2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getAspectViewbox(viewbox) {
    var viewboxDimension = 32;

    if (!viewbox) {
        return '0 0 ' + viewboxDimension + ' ' + viewboxDimension;
    }

    var _viewbox$split = viewbox.split(/ +|(?: *, *)/),
        _viewbox$split2 = (0, _slicedToArray3.default)(_viewbox$split, 4),
        width = _viewbox$split2[2],
        height = _viewbox$split2[3];

    var aspectRatio = height > 0 ? width / height : 1;

    return '0 0 ' + viewboxDimension * aspectRatio + ' ' + viewboxDimension;
}

var SvgSymbol = function SvgSymbol(_ref) {
    var theme = _ref.theme,
        id = _ref.id,
        icon = _ref.icon,
        children = _ref.children,
        arialabel = _ref.arialabel,
        ariahidden = _ref.ariahidden,
        rest = (0, _objectWithoutProperties3.default)(_ref, ['theme', 'id', 'icon', 'children', 'arialabel', 'ariahidden']);

    var aspectViewbox = getAspectViewbox(icon.viewbox);
    return _react2.default.createElement(
        'svg',
        (0, _extends3.default)({}, (0, _omit3.default)(rest, ['render', 'defs', 'icon']), {
            role: 'img',
            className: theme.root,
            'aria-hidden': ariahidden,
            viewBox: aspectViewbox
        }),
        _react2.default.createElement(
            'title',
            null,
            arialabel
        ),
        _react2.default.createElement('use', { xlinkHref: '#' + id }),
        children
    );
};

SvgSymbol.propTypes = {
    id: _propTypes2.default.string.isRequired,
    icon: _propTypes2.default.shape({
        viewbox: _propTypes2.default.string
    }).isRequired,
    render: _propTypes2.default.func.isRequired,
    ariahidden: _propTypes2.default.string,
    arialabel: _propTypes2.default.string.isRequired,
    defs: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
    children: _propTypes2.default.element,
    theme: _propTypes2.default.shape({
        root: _propTypes2.default.string
    })
};

SvgSymbol.defaultProps = {
    ariahidden: 'true',
    children: undefined,
    defs: {},
    theme: {}
};

exports.default = SvgSymbol;
//# sourceMappingURL=SvgSymbol.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-svg/lib/cjs/components/SvgSymbol.js
 ** module id = 683
 ** module chunks = 1
 **/